import React, { useState } from 'react';
import { Box, Button, TextField, CircularProgress, IconButton, Paper, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';

const UploadForm = ({ onClose }) => {
  const [image, setImage] = useState(null);
  const [location, setLocation] = useState('');
  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', image);
    formData.append('location', location);
    formData.append('date', date);

    try {
      setLoading(true); // Show the loading spinner
      await axios.post(`${process.env.REACT_APP_API_URL}/api/dates/upload`, formData);
      alert('Upload successful!');
      setImage(null);
      onClose();
      window.location.reload();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 4, position: 'relative', width: 350 }}>
      {loading ? (
        // Show the loading spinner when uploading
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        // Show the upload form when not uploading
        <>
          <IconButton
            onClick={onClose}
            sx={{ position: 'absolute', top: 10, right: 10 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Upload a Memory
          </Typography>
          <form onSubmit={handleSubmit}>
            <Button variant="outlined" component="label" fullWidth sx={{ mb: 2 }}>
              {image ? image.name : 'Choose File'}
              <input
                type="file"
                hidden
                onChange={(e) => setImage(e.target.files[0])}
                required
              />
            </Button>
            <TextField
              label="Location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
            <TextField
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              fullWidth
              required
              sx={{ mb: 2 }}
              InputLabelProps={{ shrink: true }}
            />
            <Button type="submit" variant="contained" fullWidth>
              Upload
            </Button>
          </form>
        </>
      )}
    </Paper>
  );  
};

export default UploadForm;
